module.exports = __webpack_public_path__ + "static/media/set_goal.95230cd7.png";